{
  "w": 56,
  "h": 36,
  "rows": [
    "........................................................",
    "........WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW........",
    ".....MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM.....",
    "...MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM...",
    "MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM",
    "MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM",
    "MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM",
    "MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM",
    "MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM",
    "MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM",
    "MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM",
    "MMMMccccccccccccccccccccccccccccccccccccccccccccccccMMMM",
    "MMMMccccccccccccccccccccccccccccccccccccccccccccccccMMMM",
    "MMMMccccccccccccccccccccccccccccccccccccccccccccccccMMMM",
    "MMMMccccccccccccccccccccccccccccccccccccccccccccccccMMMM",
    "MKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "YYYYKmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmKYYYY",
    "YYYYKmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmKYYYY",
    "YYYYKmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmKYYYY",
    "YYYYKmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmKYYYY",
    "YYYYKmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmKYYYY",
    "YYYYKmmmmmmmmmmmmmmmwwwwwwwwwwwwwwwwmmmmmmmmmmmmmmmKYYYY",
    "MmmmmmmmmmmmmmmmmmmKKKKKKKKKKKKKKKKKKmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "KKKKWKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKWKKKK",
    "............KKKKKKK..................KKKKKKK............",
    "........................................................"
  ],
  "legend": {
    "K": "C.BLACK",
    "M": "C.B_MAGENTA",
    "m": "C.MAGENTA",
    "C": "C.B_CYAN",
    "c": "C.CYAN",
    "W": "C.B_WHITE",
    "w": "C.WHITE",
    "Y": "C.B_YELLOW"
  }
}
